import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

const { color } = baseVariables;

export const StyledPropertyList = styled.div`
  background-color: ${color.neutral10};
`;
